import { ProposalsProps } from 'lib/types'
import { useAppSelector } from '../../../reducers/hooks'
import { useState, useEffect } from 'react'

type ProposalsData = {
    siteDesignName: string,
    xProtectPlatform: string,
    overhead: string,
    userData: any,
    date: string,
    hasError: boolean,
    errorMessage: string,
    hardwareType: number,
    hasManagementServer: boolean,
    managementServerTableBody: string[][],
    supportedCamerasValue: number,
    totalNumberOfCameras: number
}

export const useProposalsData = (proposals: ProposalsProps): ProposalsData => {

    const [proposalCalculationData, setProposalCalculationData] = useState(proposals?.calculationData?.data);
    const [proposalSiteDesignData, setProposalSiteDesignData] = useState(proposals?.siteDesignData);
    useEffect(() => {
        if (proposals) {
            setProposalCalculationData(proposals.calculationData?.data);
            setProposalSiteDesignData(proposals.siteDesignData);
        }
    }, [proposals]);

    const hasError = proposalCalculationData ? !proposalCalculationData?.calculationSuccess : false;
    const errorMessage = proposalCalculationData?.errorMessage;

    const siteDesignName = proposalCalculationData?.siteDesignName;
    const xProtectPlatform = proposalCalculationData?.xProtectPlatform;
    const overhead = proposalCalculationData?.overhead;
    const userData = useAppSelector(state => state.user.userData);

    const getDate = (): string => {
        const date = new Date(proposalCalculationData?.siteDesignDateUtc);
        const [month, day, year] = [date.toLocaleString('default', { month: 'long' }), date.getDate(), date.getFullYear()];
        return `${month} ${day}, ${year}`;
    }
    const date = getDate();

    //Get the hardware type
    const hardwareType = proposals?.siteDesignData?.siteDesign?.serverSettings?.hardwareType;

    //Managment Server Settings
    const hasManagementServer = hardwareType === 0 ?
        proposalSiteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.addManagementServer :
        proposalSiteDesignData?.siteDesign?.serverSettings?.huskyServerSettings?.addManagementServer;

    const managementServerTableBody: string[][] = [
        [
            proposalCalculationData?.managementServer?.cpuType,
            proposalCalculationData?.managementServer?.osDisk,
            proposalCalculationData?.managementServer?.diskType,
            proposalCalculationData?.managementServer?.ram
        ],
        [
            proposalCalculationData?.managementServer?.databaseStorage?.quantity,
            proposalCalculationData?.managementServer?.databaseStorage?.diskType,
            proposalCalculationData?.managementServer?.databaseStorage?.diskSize,
            proposalCalculationData?.managementServer?.databaseStorage?.raidType
        ],
        [
            proposalCalculationData?.managementServer?.sqlServer,
        ]
    ]
    const supportedCamerasValue = hardwareType === 0 ?
        proposalSiteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.managementServerSettings?.supportedCameras :
        proposalSiteDesignData?.siteDesign?.serverSettings?.huskyServerSettings?.managementServerSettings?.supportedCameras;

    let totalNumberOfCameras = Math.ceil(proposalSiteDesignData?.siteDesign?.cameras?.reduce((sum, camera) => sum + camera?.quantity, 0));

    return {
        siteDesignName,
        xProtectPlatform,
        overhead,
        userData,
        date,
        hasError,
        errorMessage,
        hardwareType,
        hasManagementServer,
        managementServerTableBody,
        supportedCamerasValue,
        totalNumberOfCameras
    }
}